import { ShopifyIntegration } from "@redotech/redo-shopify-common/shopify";
import { StorefrontPlatform } from "@redotech/redo-storefront-common/storefront-config";
import { GetTeam, Team } from "@redotech/redo-team-common/team";
import { createContext } from "react";

export type TeamContextValue =
  | (Team & {
      featureFlags: GetTeam["featureFlags"];
      platform: StorefrontPlatform;
      shopifyIntegration?: ShopifyIntegration;
      updatePermissionsLink?: string;
      ianaTimezone?: string;
      /** Computed by GET /team; true only for Redo demo stores. */
      isDemoStore?: boolean;
    })
  | undefined;
export const TeamContext = createContext<TeamContextValue>(undefined);

export const ReloadTeamContext = createContext<(() => void) | undefined>(
  undefined,
);
